<template>
  <div class="home-container mx-auto min-h-screen" @click="handleClickOverlay">
    <HomeHeader
      ref="homeHeader"
      @change-tabs="handleChangeTabs"
      @search="handleSearch"
      :activeTab="activeTab"
      :scrollProgress="scrollProgress" />
    <div class="md:mx-4 px-4 bg-white">
      <div v-if="activeTab !== 2" class="py-2">
        <div v-for="(item, index) in properties" :key="item.id">
          <ScrollGrid :index="index" :isZh="isZh" :classifyItem="item" :items="item.spuList" @updateFavorite="handleUpdateFavorite" />
        </div>
      </div>
      <div v-if="activeTab === 2" class="promotional-features py-3 bg-white mt-3 rounded-lg">
        <div v-for="feature in promotionalFeatures" :key="feature.id" class="flex items-center pr-2">
          <img :src="feature.src" class="w-12 h-12 mr-2" />
          <div class="flex-1 text-gray-800 text-base font-medium leading-relaxed">{{ $t(`home.features.${feature.key}`) }}</div>
        </div>
      </div>
    </div>

    <!-- 提示弹框组件 -->
    <TipDialog :visible.sync="tipDialogVisible" :type="tipDialogType" @button-click="handleTipAction" @close="handleTipClose" />

    <div class="md:mx-4 p-4 bg-[#f7f7f7] text-[14px]" v-if="configFootInfo">
      <div class="text-[15px] font-bold">{{ $t("foot.about") }}</div>
      <div class="text-[15px]">
        {{ isZh ? configFootInfo.about && configFootInfo.about.content : configFootInfo.aboutEn && configFootInfo.aboutEn.content }}
      </div>
      <div class="text-[15px] font-bold mt-2 mb-1 mt-5">{{ $t("foot.contact") }}</div>
      <div class="flex items-center">
        <img :src="imageBaseUrl + (configFootInfo.concatEmail && configFootInfo.concatEmail.icon)" class="w-5 h-5 mr-2" alt="" />
        <span>{{ configFootInfo.concatEmail && configFootInfo.concatEmail.content }}</span>
      </div>
      <div class="flex items-center" v-if="configFootInfo.concatPhone && configFootInfo.concatPhone.content">
        <img :src="imageBaseUrl + configFootInfo.concatPhone && configFootInfo.concatPhone.icon" class="w-5 h-5 mr-2" alt="" />
        <span>{{ configFootInfo.concatPhone && configFootInfo.concatPhone.content }}</span>
      </div>
      <div class="flex items-center" v-if="isZh && configFootInfo.address && configFootInfo.address.content">
        <img :src="imageBaseUrl + configFootInfo.address && configFootInfo.address.icon" class="w-5 h-5  mr-2" alt="地址" />
        <span>{{ configFootInfo.address && configFootInfo.address.content }}</span>
      </div>
      <div class="flex items-center" v-if="!isZh && configFootInfo.addressEn && configFootInfo.addressEn.content">
        <img :src="imageBaseUrl + configFootInfo.addressEn && configFootInfo.addressEn.icon" class="w-5 h-5  mr-2" alt="地址" />
        <span>{{ configFootInfo.addressEn && configFootInfo.addressEn.content }}</span>
      </div>
      <!-- 关注我们 -->
      <div class="text-[15px] font-bold mt-2 mb-1 mt-7">{{ $t("foot.follow") }}</div>
      <div class="flex items-center">
        <img
          :src="imageBaseUrl + item.icon"
          class="w-5 h-5 mr-2"
          v-for="(item, index) in configFootInfo.followList"
          :key="index"
          @click="handleFollow(item)" />
      </div>
      <!-- 付款方式 -->
      <div class="text-[15px] font-bold mt-2 mb-1 mt-7">{{ $t("foot.payment") }}</div>
      <div class="flex items-center flex-wrap gap-y-2">
        <img :src="imageBaseUrl + item.icon" class="w-auto h-5 mr-3" v-for="(item, index) in configFootInfo.payList" :key="index" />
      </div>
      <!-- 页脚协议 -->
      <div class="text-[14px] mt-7 mb-1 text-[#ff7a00] flex justify-center flex-wrap gap-y-2">
        <span v-for="(item, index) in configFootInfo.articleList" :key="index" @click="handleArticle(item)" class="cursor-pointer">
            {{ isZh ? item.title : item.titleEn }}
            <span v-if="index < configFootInfo.articleList.length - 1" class="mx-2">|</span>
          </span>
      </div>

      <div class="w-full text-center my-5 ">
        <div>©{{ configFootInfo.year }} {{ isZh ? "yoyotravel 版权所有" : "yoyotravel All Rights Reserved" }}</div>
        <div class="text-[13px] text-gray-400">{{configFootInfo.copyrightNo.content}}</div>
      </div>
    </div>
    <div class="safe-area bg-[#f7f7f7]" :class="{ 'translate-y-full': !showTabbar }"></div>
    <van-tabbar route :class="['z-999 transition-transform duration-300 flex md:hidden', { 'translate-y-full': !showTabbar }]">
      <van-tabbar-item :to="item.to" v-for="item in tabbarItems" :key="item.name">
        <template #icon>
          <img :src="item.icon" class="w-14 h-14" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import HomeHeader from "@/components/home/HomeHeader.vue"
import PropertyGrid from "@/components/home/PropertyGrid.vue"
import ScrollGrid from "@/components/home/ScrollGrid.vue"
import TipDialog from "@/components/home/TipDialog.vue"
import { Locale, Tabbar, TabbarItem } from "vant"
// 引入英文语言包
import enUS from "vant/es/locale/lang/en-US"
import zhCN from "vant/es/locale/lang/zh-CN"
import { mapActions, mapGetters, mapMutations } from "vuex"
import { getCategoryList } from "@/apis/shop"
import { getConfigFootList } from "@/apis/common"
import { updateLanguage } from "@/apis/userInfo"


export default {
  name: "Home",
  components: {
    HomeHeader,
    PropertyGrid,
    ScrollGrid,
    TipDialog,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
  data() {
    return {
      properties: [],
      promotionalFeatures: [
        { id: 1, key: "register", icon: "user-circle-o", src: require("@/assets/images/mine/001.png"), class: "w-6 h-6" },
        { id: 2, key: "discount", icon: "gold-coin-o", src: require("@/assets/images/mine/002.png"), class: "w-5 h-5" },
        { id: 3, key: "packages", icon: "globe", src: require("@/assets/images/mine/005.png"), class: "w-6 h-6" },
        { id: 4, key: "esimFree", icon: "send-gift-o", src: require("@/assets/images/mine/003.png"), class: "w-5 h-5" },
        { id: 5, key: "simple", icon: "like-o", src: require("@/assets/images/mine/004.png"), class: "w-5 h-5" },
        { id: 6, key: "gifts", icon: "gift-o", src: require("@/assets/images/mine/006.png"), class: "w-5 h-5" },
      ],
      activeTab: 0,
      // 提示弹框相关
      tipDialogVisible: false,
      tipDialogType: "language", // 'language', 'password', 'review'

      active: 1,
      // tabbarItems: [
      //   { name: "cart", icon: require("@/assets/images/card.png"), to: { name: "cart", query: { showTabbar: true } }, w: 8 },
      //   { name: "home", icon: require("@/assets/images/home.png"), to: { name: "home" }, w: 8 },
      //   { name: "yoyoCoinIntroduce", icon: require("@/assets/images/yoyo.png"), to: { name: "yoyoCoinIntroduce" }, w: 10 },
      //   { name: "mine", icon: require("@/assets/images/mine.png"), to: { name: "mine" }, w: 10 },
      // ],

      // 滚动相关状态
      showTabbar: true,
      lastScrollTop: 0,
      scrollThreshold: 1, // 滚动阈值
      configFootInfo: '',
      // HomeHeader 相关
      scrollProgress: 0, // 0-1 之间的滚动进度，用于HomeHeader动画
      maxScrollForHeaderAnimation: 80, // HomeHeader动画完成的最大滚动距离
      lastHeaderScrollTop: 0, // 上次更新Header时的scrollTop位置
    }
  },
  methods: {
    ...mapMutations({
      setIsShowPasswordDialog: "auth/SET_IS_SHOW_PASSWORD_DIALOG",
      setIsShowReviewDialog: "auth/SET_IS_SHOW_REVIEW_DIALOG",
      setLoginDialogVisible: "auth/SET_LOGIN_DIALOG_VISIBLE",
      setInviteRegisterDialogVisible: "auth/SET_INVITE_REGISTER_DIALOG_VISIBLE",
      setIsFirstEnterHome: "auth/SET_IS_FIRST_ENTER_HOME",
      setIsZh: "lang/SET_IS_ZH",
      addProcessedInviteCode: "auth/ADD_PROCESSED_INVITE_CODE",
    }),
    ...mapActions({
      fetchUserInfo: "auth/fetchUserInfo",
    }),
    handleFollow(item) {
      if (item.content) {
        window.open(item.content)
      }
    },
    handleArticle(item) {
      this.$router.push({ name: "article", query: { id: item.id } })
    },
    async queryCategoryList() {
      try {
        // console.log("this.activeTab :>> ", this.activeTab)
        const type = this.activeTab === 1 ? "SIM" : "eSIM"
        const res = await getCategoryList({ type })
        this.properties = res.data
        // console.log("categoryList :>> ", res)
      } catch (error) {
        console.log("error :>> ", error)
      }
    },
    // 处理滚动事件 - 结合两者优点的混合逻辑
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      // 1. 立即更新 HomeHeader 的滚动进度（实时响应，无防抖）
      this.updateHeaderScrollProgress(scrollTop)

      // 2. 立即更新 Tabbar 显示逻辑（实时响应，无防抖）
      this.updateTabbarVisibility(scrollTop, windowHeight, documentHeight)
    },

    // HomeHeader 滚动进度更新（防抖动优化版本）
    updateHeaderScrollProgress(scrollTop) {
      // 1. 计算scrollTop变化量
      const scrollDiff = Math.abs(scrollTop - this.lastHeaderScrollTop)

      // 检测滚动方向
      const scrollDirection = scrollTop > this.lastHeaderScrollTop ? "down" : "up"

      // 2. 设置阈值：只有滚动距离超过3px才更新
      const scrollThreshold = 3

      // console.log(
      //   "🎯 [滚动检测] scrollTop:",
      //   scrollTop.toFixed(2),
      //   "上次:",
      //   this.lastHeaderScrollTop.toFixed(2),
      //   "差值:",
      //   scrollDiff.toFixed(2),
      //   "px",
      //   "方向:",
      //   scrollDirection
      // )

      // 3. 检测反向跳动（闪动的特征）
      // 如果滚动方向改变且变化量较小（< 4px），可能是闪动
      if (this._lastScrollDirection && scrollDirection !== this._lastScrollDirection && scrollDiff < 4) {
        // 增加跳动计数
        this._bounceCount = (this._bounceCount || 0) + 1
        // console.log("⚠️ [检测到反向跳动]", this._bounceCount, "次，停止更新以防止闪动")

        // 进入保护模式：暂停更新200ms，让动画稳定
        if (!this._protectionMode) {
          this._protectionMode = true
          // console.log("🛡️ [启动保护模式] 暂停200ms")
          if (this._protectionTimeout) clearTimeout(this._protectionTimeout)
          this._protectionTimeout = setTimeout(() => {
            this._protectionMode = false
            this._bounceCount = 0
            this._lastScrollDirection = null
            // console.log("✅ [保护模式结束]")
          }, 200)
        }

        return
      }

      // 如果在保护模式中，只允许大幅度的单向滚动
      if (this._protectionMode && scrollDiff < 10) {
        // console.log("🛡️ [保护模式中] 忽略小幅度滚动")
        return
      }

      // 如果滚动方向一致且幅度足够大，重置跳动计数
      if (this._lastScrollDirection === scrollDirection && scrollDiff >= 5) {
        this._bounceCount = 0
      }
      this._lastScrollDirection = scrollDirection

      // 4. 如果变化量小于阈值，直接跳过
      if (scrollDiff < scrollThreshold) {
        // console.log("⏸️ [跳过更新] 变化太小 (<", scrollThreshold, "px)")
        return
      }

      // 4. 计算新的进度值
      const rawProgress = Math.min(scrollTop / this.maxScrollForHeaderAnimation, 1)

      // 5. 四舍五入到小数点后2位，进一步减少微小变化
      const roundedProgress = Math.round(rawProgress * 100) / 100

      // 6. 检查进度是否真的变化了
      if (Math.abs(roundedProgress - this.scrollProgress) < 0.01) {
        // console.log("⏸️ [跳过更新] 进度值未变化，当前:", this.scrollProgress)
        // 即使进度没变，也更新lastHeaderScrollTop，避免累积效应
        this.lastHeaderScrollTop = scrollTop
        return
      }

      // 7. 更新进度和记录位置
      // console.log("✅ [更新进度]", this.scrollProgress.toFixed(3), "→", roundedProgress.toFixed(3), "| scrollTop:", scrollTop.toFixed(2))
      this.scrollProgress = roundedProgress
      this.lastHeaderScrollTop = scrollTop
    },

    // Tabbar 显示逻辑（来自 Home.vue 的简单逻辑）
    updateTabbarVisibility(scrollTop, windowHeight, documentHeight) {
      // 顶部保护：在接近页面顶部（含 iOS 回弹的轻微负/正偏移）时，始终显示 tabbar
      const topBuffer = 2
      if (scrollTop <= topBuffer) {
        this.showTabbar = true
        this.lastScrollTop = 0
        return
      }
      // 判断是否滚动到页面底部（距离底部50px内）
      const isNearBottom = scrollTop + windowHeight >= documentHeight - 1

      // 如果在页面底部，显示tabbar
      if (isNearBottom) {
        this.showTabbar = true
        this.lastScrollTop = scrollTop
        return
      }

      // 判断滚动方向
      const scrollDirection = scrollTop > this.lastScrollTop ? "down" : "up"

      // 只有滚动距离超过阈值才触发显示/隐藏
      if (Math.abs(scrollTop - this.lastScrollTop) > this.scrollThreshold) {
        if (scrollDirection === "down") {
          // 向下滚动，隐藏tabbar
          this.showTabbar = false
        } else {
          // 向上滚动，显示tabbar
          this.showTabbar = true
        }
        this.lastScrollTop = scrollTop
      }
    },

    handleGoList(item) {
      this.$router.push({ name: "productsList", query: { id: item.id } })
    },
    handleSearch(iccid) {
      if (!this.isLoggedIn) {
        this.setLoginDialogVisible(true)
      } else {
        this.$router.push({ path: "/query", query: { iccid } })
      }
    },
    handleChangeTabs(index) {
      this.activeTab = index
      if (index !== 2) {
        this.queryCategoryList()
      }
    },
    // 显示不同类型的提示弹框
    showLanguageDialog() {
      this.tipDialogType = "language"
      this.tipDialogVisible = true
    },
    showPasswordDialog() {
      this.tipDialogType = "password"
      this.tipDialogVisible = true
    },
    showReviewDialog() {
      this.tipDialogType = "review"
      this.tipDialogVisible = true
    },

    // 处理提示弹框按钮点击
    handleTipAction({ action }) {
      console.log(`提示弹框操作 - 类型: ${this.tipDialogType}, 操作: ${action}`)

      // 根据不同类型和操作处理逻辑
      if (this.tipDialogType === "language") {
        // 切换语言，持久化到 localStorage
        const newLang = action === "english" ? "en" : "zh-CN"
        this.$i18n.locale = newLang
        Locale.use(newLang === "en" ? "en-US" : "zh-CN", newLang === "en" ? enUS : zhCN)
        localStorage.setItem("lang", newLang)
        this.setIsZh(newLang === "zh-CN")
        if (this.isLoggedIn) {
          updateLanguage({ lang: newLang === "zh-CN" ? "zh" : "en" }).then(() => {
            console.log("语言更新成功")
          }).catch((error) => {
            console.log("语言更新失败 :>> ", error)
          })
        }
        
        // 触发界面重新渲染，以确保文本切换生效
        this.$forceUpdate()
        this.handleTipClose()
      } else if (this.tipDialogType === "password") {
        if (action === "setPassword") {
          console.log("跳转到密码设置页面")
          // 可以在这里跳转到密码设置页面
          this.$router.push("/user-info")
        } else if (action === "later") {
          this.handleTipClose()
        }
      } else if (this.tipDialogType === "review") {
        if (action === "review") {
          console.log("跳转到评价页面")
          // 可以在这里跳转到评价页面
        } else if (action === "later") {
          this.handleTipClose()
        }
      }
    },

    // 处理提示弹框关闭
    handleTipClose() {
      console.log(`提示弹框关闭 - 类型: ${this.tipDialogType}`)
      this.tipDialogVisible = false
      if (this.tipDialogType === "password") {
        this.setIsShowPasswordDialog("false")
      } else if (this.tipDialogType === "review") {
        this.setIsShowReviewDialog("false")
      }
    },
    handleUpdateFavorite(id, favorite) {
      this.queryCategoryList()
    },
    async queryConfigFootList() {
      try {
        const res = await getConfigFootList()
        this.configFootInfo = res.data
        // console.log("configFootInfo :>> ", res)
      } catch (error) {
        console.log("error :>> ", error)
      }
    },
    handleClickOverlay() {
      this.$refs.homeHeader.showPlaceList = false
      this.$refs.homeHeader.searchText = ""
    },
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn",
      isFirstEnterHome: "auth/isFirstEnterHome",
      userInfo: "auth/userInfo",
      isZh: "lang/isZh",
      isShowPasswordDialog: "auth/isShowPasswordDialog",
      isShowReviewDialog: "auth/isShowReviewDialog",
      processedInviteCodes: "auth/processedInviteCodes",
    }),
    imageBaseUrl() {
      return process.env.VUE_APP_IMAGE_URL
    },
    tabbarItems() {
      return this.isZh
        ? [
            { name: "home", icon: require("@/assets/images/tabbar/home-active.png"), to: { name: "home" }, w: 8 },
            { name: "yoyoCoinIntroduce", icon: require("@/assets/images/tabbar/yoyo.png"), to: { name: "yoyoCoinIntroduce" }, w: 10 },
            { name: "cart", icon: require("@/assets/images/tabbar/cart.png"), to: { name: "cart", query: { showTabbar: true } }, w: 8 },
            { name: "mine", icon: require("@/assets/images/tabbar/my.png"), to: { name: "mine" }, w: 10 },
          ]
        : [
            { name: "home", icon: require("@/assets/images/tabbar/home-en-active.png"), to: { name: "home" }, w: 8 },
            { name: "yoyoCoinIntroduce", icon: require("@/assets/images/tabbar/yoyo-en.png"), to: { name: "yoyoCoinIntroduce" }, w: 10 },
            { name: "cart", icon: require("@/assets/images/tabbar/cart-en.png"), to: { name: "cart", query: { showTabbar: true } }, w: 8 },
            { name: "mine", icon: require("@/assets/images/tabbar/my-en.png"), to: { name: "mine" }, w: 10 },
          ]
    },
  },

  created() {
    const query = this.$route.query
    if (query.inviteCode && query.inviteCode.length) {
      // 检查邀请码是否已经被处理过
      if (!this.processedInviteCodes.includes(query.inviteCode)) {
        this.setInviteRegisterDialogVisible(true)
        // 记录已处理的邀请码
        this.addProcessedInviteCode(query.inviteCode)
      }
    }
    // 添加滚动事件监听
    window.addEventListener("scroll", this.handleScroll, { passive: true })
    if (!localStorage.getItem("lang")) {
      this.showLanguageDialog()
    }
    try {
      this.queryCategoryList()
      this.queryConfigFootList()
    } catch (error) {
      console.log("error :>> ", error)
    }
  },
  watch: {
    userInfo: {
      handler(newVal) {
        console.log("home---userInfo :>> ", newVal, this.isLoggedIn)
        if (newVal && this.isLoggedIn) {
          if (newVal.hasUnCommentOrder && this.isShowReviewDialog === "true") {
            this.showReviewDialog()
          }
          if (newVal.hasOwnProperty('hasPassword')) {
            if (!newVal.hasPassword  && this.isShowPasswordDialog === "true") {
              this.showPasswordDialog()
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll)
  },
}
</script>

<style scoped>
/deep/.van-tabbar-item__icon img {
  height: auto;
}
.safe-area {
  height: calc(50px + env(safe-area-inset-bottom));
  /* padding-bottom: env(safe-area-inset-bottom); */
}
</style>
